"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACL_PERM_BITS = exports.ACL_NEW_FOLDER = exports.ACL_DELETE = exports.ACL_WRITE = exports.ACL_READ = exports.ACL_PERM_NONE = void 0;
exports.ACL_PERM_NONE = 0x0000;
exports.ACL_READ = 0x0001;
exports.ACL_WRITE = 0x0002;
exports.ACL_DELETE = 0x0004;
exports.ACL_NEW_FOLDER = 0x0008;
exports.ACL_PERM_BITS = exports.ACL_DELETE | exports.ACL_WRITE | exports.ACL_READ;
//# sourceMappingURL=permissions.js.map